module.exports = __webpack_public_path__ + "img/c08_unitvillager_Normal_ua.efddbed4.webp";